import { Link } from '@/i18n/navigation';
import { pathMatches } from '@/lib/util/path';
import Button from '@/ui/Button/Button';
import { logoProps, useLinks } from '@/ui/layout/NavBar/navbar-config';
import Logo from '@/ui/Logo';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import LanguageSelector from './LanguageSelector';
import styles from './NavBar.module.scss';
import ThemeSwitcher from './ThemeSwitcher';

export type NavBarContentDesktopProps = {
  pathname: string;
  logoVariant?: 'light' | 'dark';
};

const NavBarContentDesktop: React.FC<NavBarContentDesktopProps> = ({ pathname, logoVariant }) => {
  const t = useTranslations('layout.navbar');
  const links = useLinks({ kitchensink: process.env.NODE_ENV === 'development' });

  return (
    <div className={styles.content}>
      <Logo className={styles.logo} variant={logoVariant} {...logoProps} />

      <ul className={styles.links}>
        {links.map(({ href, text }) => (
          <li key={href} className={clsx({ [styles.active]: pathMatches(pathname, href) })}>
            <Link href={href}>{text}</Link>
          </li>
        ))}
      </ul>

      <div className={styles.rightNav}>
        <LanguageSelector width="max-content" />
        <ThemeSwitcher />
        <Button color="secondary" href="/contact" data-umami-event="contact-me-header">
          {t('contact-me')}
        </Button>
      </div>
    </div>
  );
};

export default NavBarContentDesktop;
